module.exports = __webpack_public_path__ + "img/profile-user.3a9dfb89.svg";